import React from 'react';
import { Provider } from 'react-redux';
import { store } from '../../store/configureStore';

function providerRedux(WrappedComponent) {
  return function ReduxProvider (props) {
    return (
      <Provider store={store}>
        <WrappedComponent {...props} />
      </Provider>
    );
  };
}

export default providerRedux;
